import { useState } from "react";
import { paradiseStill, playButton, xRodClose } from "../assets";
import { loadFonts } from "../fonts";
import "./VideoModal.css";

const YT_VIDEO_ID = "aUzzjOuue4A";

/**
 * The Paradise music video. Opens showing a still; the YouTube iframe is
 * only created once the still is clicked, so nothing loads from YouTube (and
 * nothing is tracked) until the visitor asks for it.
 */
export function VideoModal({
  open,
  onClose,
  duck,
  unduck,
}: {
  open: boolean;
  onClose: () => void;
  duck: () => void;
  unduck: () => void;
}) {
  const [playing, setPlaying] = useState(false);
  loadFonts();

  function close() {
    setPlaying(false);
    unduck();
    onClose();
  }

  return (
    <div
      id="video-overlay"
      className={open ? "open" : undefined}
      onClick={(e) => {
        if (e.target === e.currentTarget) close();
      }}
    >
      <div id="video-modal">
        <button type="button" id="video-close" aria-label="Stäng" onClick={close}>
          <img src={xRodClose} alt="Stäng" />
        </button>
        <div id="video-frame-wrap" className={playing ? "playing" : undefined}>
          <img
            id="video-thumb"
            src={paradiseStill}
            alt="Paradise"
            onClick={() => {
              setPlaying(true);
              duck();
            }}
          />
          {!playing && (
            <>
              <img id="video-play-button" src={playButton} alt="" />
              <span id="video-title">Paradise</span>
            </>
          )}
          {/* Mounted only while playing. An `src=""` resolves to the current
              document, so the closed modal used to re-request the whole page and
              React warned about it on first paint; `close()` resetting `playing`
              now also tears the frame down. Layout is unaffected: the frame is
              absolute inside a fixed-aspect wrap that the thumb covers. */}
          {playing && (
            <iframe
              id="yt-frame"
              src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
              title="Paradise - Musikvideo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </div>
    </div>
  );
}
